import { business } from "../content/business";

/**
 * BusinessHours — compact "Mon–Fri 9–6 PT" or full weekly list.
 * Reads from canonical content/business.ts — no hard-coded strings.
 */

function fmtHour(h: string): string {
  const [hh] = h.split(":");
  const n = Number(hh);
  if (!Number.isFinite(n)) return h;
  const suffix = n >= 12 ? "p" : "a";
  const display = n > 12 ? n - 12 : n === 0 ? 12 : n;
  return `${display}${suffix}`;
}

function tzLabel(tz: string): string {
  if (tz === "America/Los_Angeles") return "PT";
  if (tz === "America/New_York") return "ET";
  if (tz === "America/Chicago") return "CT";
  if (tz === "America/Denver") return "MT";
  return tz.split("/")[1]?.replace(/_/g, " ") ?? "UTC";
}

const dayLabel: Record<string, string> = {
  Mon: "Monday",
  Tue: "Tuesday",
  Wed: "Wednesday",
  Thu: "Thursday",
  Fri: "Friday",
  Sat: "Saturday",
  Sun: "Sunday",
};

export function BusinessHours({ compact = false, className }: { compact?: boolean; className?: string }) {
  const { hours } = business;
  const open = hours.schedule.filter((d) => d.open);
  const tz = tzLabel(hours.timezone);

  if (compact) {
    const first = open[0];
    const last = open[open.length - 1];
    if (!first?.open || !first.close) return <span className={className}>By appointment</span>;
    return (
      <span className={className}>
        {first.day}–{last?.day} {fmtHour(first.open)}–{fmtHour(first.close)} {tz}
      </span>
    );
  }

  return (
    <dl className={`grid grid-cols-[auto_1fr] gap-x-6 gap-y-1 text-sm ${className ?? ""}`}>
      {hours.schedule.map((d) => (
        <div key={d.day} className="contents">
          <dt className="text-[var(--nx-text-dim)]">{dayLabel[d.day] ?? d.day}</dt>
          <dd className="text-[var(--nx-text)]">
            {d.open && d.close ? `${fmtHour(d.open)} – ${fmtHour(d.close)} ${tz}` : "Closed"}
          </dd>
        </div>
      ))}
    </dl>
  );
}
